<template>
  <!-- 学费缴纳 -->
  <div>
    <home-header></home-header>
    <div class="content page-width">
      <personal-center></personal-center>
      <div class="margin-top-30"></div>
      <apply-list></apply-list>
    </div>
    <Foot></Foot>
  </div>
</template>

<script>
import HomeHeader from "@/common/components/Header";
import Foot from "@/common/components/Foot";
import ApplyList from "./components/ApplyList";
import PersonalCenter from "@/common/components/PersonalCenter";
export default {
  name: "TuitionPayment",
  components: {
    HomeHeader,
    Foot,
    ApplyList,
    PersonalCenter,
  },
  data: function () {
    return {};
  },
  created() {},
  methods: {},
};
</script>
<style lang="stylus" scoped>
@import '~styles/varibles.styl'
.page-width{
  width:$pageWidth;
  margin:0 auto;
  .content-right{
    margin-top:30px;
    .localtion{
      line-height 30px;
      border-bottom:1px solid $borderColor;
      margin-bottom:20px;
    }
  }
}
.content-left{
  background:#f7f6f6;
}
</style>



// WEBPACK FOOTER //
// src/pages/tuitionPayment/index.vue